
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flow/[category]",
      function () {
        return require("private-next-pages/flow/[category].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flow/[category]"])
      });
    }
  